import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { InfoWidget } from '@ds/react-components';
import { Typography, Grid } from '@material-ui/core';
import { ReactComponent as BCIcon } from 'assets/cardtype-bank.svg';
import { ReactComponent as AMIcon } from 'assets/cardtype-american-express.svg';
import { ReactComponent as DIIcon } from 'assets/cardtype-diners-club.svg';
import { ReactComponent as MAIcon } from 'assets/cardtype-master-card.svg';
import { ReactComponent as VIIcon } from 'assets/cardtype-visa.svg';

const styles = (theme) => ({
  root: {
    '& h4': {
      fontWeight: 'normal',
      margin: '5px 0',
    },
  },
  error: {
    color: theme.palette.common.error,
  },
  heading: {
    color: theme.palette.common.darkGray,
  },
  cardDescription: {
    paddingLeft: '10px',
  },
  accountNo: {
    color: theme.palette.common.lightText,
  },
});

const cardTypeImage = {
  AM: AMIcon,
  DI: DIIcon,
  MA: MAIcon,
  VI: VIIcon,
  BC: BCIcon,
  BA: BCIcon,
};

class PaymentMethodPreview extends React.Component {
  render() {
    const { classes, customerDetails, localisation } = this.props;
    const {
      activePaymethodAccountType,
      activePaymethodCCType,
      activePaymethodAccountNo,
      activePaymethodAccountHolder,
      adfitNo,
    } = customerDetails;
    const payMethodDescr = `${
      activePaymethodAccountType === 'BA' ? 'from account' : 'on card'
    } ending in ${activePaymethodAccountNo}`;
    const cardType = activePaymethodCCType
      ? activePaymethodCCType
      : activePaymethodAccountType
      ? activePaymethodAccountType
      : '';
    const CardImage = cardTypeImage[cardType]
      ? cardTypeImage[cardType]
      : localisation.prompts.cardType
      ? localisation.prompts.cardType[cardType]
      : null;
    return (
      <InfoWidget
        title={'Payment Method'}
        isLoading={!adfitNo}
        classes={{ root: classes.root }}>
        {activePaymethodAccountNo ? (
          <Grid container direction="row">
            <Grid item>{CardImage && <CardImage />}</Grid>
            <Grid item className={classes.cardDescription}>
              <Typography variant="body1" className={classes.heading}>
                {activePaymethodAccountHolder}
              </Typography>
              <Typography variant="body1" className={classes.accountNo}>
                {payMethodDescr}
              </Typography>
            </Grid>
          </Grid>
        ) : (
          <Grid container direction="row">
            <Grid item>
              <Typography variant="body1" className={classes.accountNo}>
                None
              </Typography>
            </Grid>
          </Grid>
        )}
      </InfoWidget>
    );
  }
}
PaymentMethodPreview.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PaymentMethodPreview);
